var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.componentType,{tag:"component",attrs:{"pin-info":_vm.pinInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }